import { render, staticRenderFns } from "./InitialData.vue?vue&type=template&id=0a8209c0"
import script from "./InitialData.vue?vue&type=script&lang=js"
export * from "./InitialData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports